/*
 * Created Date: 23-01-2023, 9:46:32 am
 * Author: Hai Tran
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2023 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'

class School extends BaseService {
	BASE_ENDPOINT = '/quiz/api/v1/user/schools'

	listWithOptions = (query = {}, config = {}) => {
		const params = {
			...this.paramsGet,
			page: 1,
			size: this.ALL_ITEMS,
			is_active: true,
			...query
		}
		return this.withCache(
			() => this.request.get(this.BASE_ENDPOINT, { params, ...config }),
			`${this.BASE_ENDPOINT}-${JSON.stringify(params)}`
		)
	}
}

export const schoolService = new School()
